import React from 'react';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function InfoCircleSolidIcon(props) {
  return <FontAwesomeIcon icon={faInfoCircle} {...props} />;
}
